import React from "react";
import CalculatedPayment, { CalculatedPaymentProps } from "Shared/CalculatedPayment";
import styled from "styled-components";

const StyledCalculatedPayment = styled(CalculatedPayment)`
    display: inline !important;
    min-height: 0 !important;
    padding: 0 !important;

    .CalculatedPayment__payment {
        font-size: inherit;
    }

    .CalculatedPayment__copy {
        font-size: inherit;
    }

    .CalculatedPayment__container--cash {
        display: inline;
    }

    &.CalculatedPayment__NoOffer {
        display: inline-flex !important;

        span {
            font-size: inherit !important;
        }
    }
`;

const CalculatedPaymentInline = (props: CalculatedPaymentProps) => {
    return (
        <StyledCalculatedPayment
            {...props}
            inGarage={true}
            displayPaymentInfo={false}
            displayCashLabel={false}
            showAPR={false}
        />
    );
};

export default CalculatedPaymentInline;
